import { z } from 'zod';
import { defaultPaginatedQuery, paginatedQuerySchema } from '~/util/types/api';

export const moderatorStatsParamsSchema = z
    .object({
        shifts: paginatedQuerySchema().default(defaultPaginatedQuery),
    })
    .extend(paginatedQuerySchema({ default_per_page: 31 }).shape);

export type moderatorStatsParams = z.input<typeof moderatorStatsParamsSchema>;
export const defaultModeratorStatsParams = moderatorStatsParamsSchema.parse({});
